import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const HeaderSearchMobile = ()=>{
    const navigate = useNavigate();
    const { school } = useParams();
    const [keyword, setkeyword] = useState("");
    function submitHandler(event){
        navigate({pathname:`/${school}/book`, search:`?search=Y&search_keyword=${ encodeURIComponent(keyword)}` });
        event.preventDefault();
    }
    
    return (
        <div id="search_area_wrap">
            <h3>SEARCH</h3>
            <button type="button" id="search_close_btn" onClick={()=>{window.$("#search_area_wrap").toggleClass("on");}}><span></span><span></span></button>
            <div className="search_area">
                <form onSubmit={submitHandler}>
                    <input type="text" className="search_input" placeholder="도서검색"
                        name="keyword" value={keyword} onChange={(e)=>setkeyword(e.target.value)} />
                    <button  className="search_btn"></button>
                </form>
            </div>
        </div>
    );
}
